<template>
  <a-modal
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    width="50%"
    cancelText="取消"
    okText="确认"
    title="Live broadcast room configuration（直播间配置）"
  >
    <a-form
      ref="formRef"
      :model="form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      :rules="rules"
    >
      <a-form-item label="直播间号" name="chatGroupId">
        <a-input
          v-model:value="form.chatGroupId"
          placeholder="请输入"
          :disabled="editType === 2"
        />
      </a-form-item>
      <a-form-item label="直播间名" name="chatGroupName">
        <a-input v-model:value="form.chatGroupName" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="直播流地址" name="liveStreamUrl">
        <a-input v-model:value="form.liveStreamUrl" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="有效期" name="emptyTime">
        <a-range-picker
          v-model:value="form.emptyTime"
          :format="'YYYY-MM-DD HH:mm:ss'"
          show-time
          @change="changeRangePicker"
          :placeholder="['开始时间', '结束时间']"
        />
      </a-form-item>
      <a-form-item label="PDP" name="pdp">
        <a-switch
          v-model:checked="form.pdp"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
        />
      </a-form-item>
      <a-form-item label="Collection" name="collection">
        <a-switch
          v-model:checked="form.collection"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
        />
      </a-form-item>
      <a-form-item label="首页版位" name="home">
        <a-switch
          v-model:checked="form.home"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
        />
      </a-form-item>
      <a-form-item label="专题页" name="specialPage">
        <a-switch
          v-model:checked="form.specialPage"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
        />
      </a-form-item>
      <a-form-item label="直播头像" name="faceUrl">
        <UpdateImage
          v-if="modalVisible"
          :imageType="imageType1"
          :defaultUrl="form.faceUrl"
          @setFaceUrl="setFaceUrl"
          @delFaceImg="delFaceImg"
        ></UpdateImage>
      </a-form-item>
      <a-form-item label="直播封面" name="bgUrl">
        <UploadBgImg
          v-if="modalVisible"
          :imageType="imageType2"
          :defaultUrl="form.bgUrl"
          @setBgUrl="setBgUrl"
          @delBgImg="delBgImg"
        ></UploadBgImg>
      </a-form-item>
      <a-form-item label="左侧商品池" name="leftSeoUrl">
        <!-- <a-radio-group v-model:value="form.leftGoodsSearchType">
          <a-radio value="0">SKC code</a-radio>
          <a-radio value="1">collection</a-radio>
        </a-radio-group> -->
        <a-form-item-rest>
          <a-input
            v-model:value="form.leftSeoUrl"
            placeholder="请输入seoUrl"
          ></a-input>
        </a-form-item-rest>
      </a-form-item>
      <a-form-item label="直播瀑布流" name="flowSeoUrl">
        <!-- <a-radio-group v-model:value="form.flowGoodsSearchType">
          <a-radio value="0">SKC code</a-radio>
          <a-radio value="1">collection</a-radio>
        </a-radio-group> -->
        <a-form-item-rest>
          <a-input
            v-model:value="form.flowSeoUrl"
            placeholder="请输入seoUrl"
          ></a-input>
        </a-form-item-rest>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
import UpdateImage from './UploadImg.vue'
import UploadBgImg from './UploadBgImg.vue'
export default {
  components: {
    UpdateImage,
    UploadBgImg
  },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
